// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2vqdf","bigColWidth":"Table_bigColWidth__15rH7","biggerColWidth":"Table_biggerColWidth__3Xftp","row":"Table_row__2KLtc","col":"Table_col__3_5dN"};